module.exports = __webpack_public_path__ + "media/assets/images/full-cover-b32e2fbe6598a8fe04a5097f23fed5cf.svg";